/**
 * Default requirements JSON for the DynamicForm playground.
 * Uses the "simple" example schema (Beneficiary Registration).
 */
import { DEFAULT_SCHEMA_JSON } from "./schemas";

export const DEFAULT_REQUIREMENTS_JSON = DEFAULT_SCHEMA_JSON;
